import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Root from './components/Root/Root';

import AppAdmin from './components/App-Admin/App-Admin';
import { Initializer } from './initializer';
import { IAppSettings } from './components/App-Client/App-Client';

window.addEventListener('DOMContentLoaded', () => {
	const webGlAvailable = Initializer.webGlAvailable();

	//Abort if we have no webGL-support
	//FIXME: for debugging purposes use Firefox => about:config => webgl.disabled  
	if (!webGlAvailable) {
		console.warn("Warning: WebGL is currently disabled. 3D widgets will not display correctly.")
		return;
	};

	Initializer.getWidgetSettings()
	.then((widgetSettings:IAppSettings) => {
    const rootDiv = document.getElementById(widgetSettings.rootDivId);
    const assetPath = widgetSettings.assetPath;

		try {
      ReactDOM.render(
            <Root>
              <AppAdmin 
                rootDiv = {rootDiv}
                assetPath = {assetPath}
              />
            </Root>,
        rootDiv
      );
    } catch (e) {
      // console.log("Could not find container element. Please make sure an element with id='"+ widgetSettings.rootDivId +"' exists.", e);
    }
	})
})